import { reactive } from "vue";

const globals = reactive({
    searchText: '',
    loaded: false,
    error: null,          // auth/session errors — drives the re-login modal
    dataWarning: null,    // v10 data-contract issues — drives a non-blocking footer note
    showStudentList: false,
    LOGIN_REDIRECT: null
});

export default globals;
